import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState, Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { CategoryPageRoutingModule } from './category-page-routing.module';
import { CategorySeoComponent } from './components/category-seo/category-seo.component';
import { CategoryPageResolver } from './guards/category-resolver.guard';
import { CategoryLayoutComponent } from './layouts/category-layout.component';
import { CategoryGridModule } from './modules/category-grid/category-grid.module';
import { CategoryFilterBadgeComponent } from './modules/filters/components/category-filter-badge/category-filter-badge.component';
import { DisplayFilterComponent } from './modules/filters/components/display-filter/display-filter.component';
import { CategoryPageService } from './services/category-page.service';
import { ChangeUrlService } from './services/change-url.service';
import { ProductFilterService } from './services/product-filter.service';
import { CategoryPageEffects } from './store/category-page.effects';
import { CategoryPageReducer } from './store/category-page.reducer';
import { GridTypeEffects } from './store/grid-type/grid-type.effects';

import { CategoryFeatureModule } from '@features/category/category-feature.module';
import { CmsRenderLazyComponent } from '@features/cms-render';
import { ProductsArrayFeatureCoreModule } from '@features/products/productsArray/productsArray-feature.core.module';
import { LoadAnalyticsModule } from '@shared/analytics/store/analytics.actions';
import { BreadcrumbsModule } from '@shared/breadcrumbs/breadcrumbs.module';
import { CategoryToolbarModule } from '@shared/category-toolbar/category-toolbar.module';
import { ElementObserverDirective } from '@shared/directives/element-observer.directive';
import { MenuCategoriesService } from '@shared/menu-categories/services/menu-categories.service';
import { ProductModule } from '@shared/product/product.module';
import { RelatedProductsComponent } from '@shared/product/related-products';
import { RelatedProductsCoreModule } from '@shared/product/related-products/related-products-core.module';
import { HeraclesService } from '@shared/services/heracles/heracles.service';
import { StaticResourceService } from '@shared/services/static-resources/static-resource.service';
import { HideOnScrollDirective } from '@ui/directives/hide-on-scroll/hide-on-scroll.directive';
import { ParagraphToggleComponent } from '@ui/paragraph-toggle/paragraph-toggle.component';

@NgModule({
    imports: [
        BreadcrumbsModule,
        CategoryFeatureModule, // se tendría que dividir CategoryFeatureModule y CategoriesFeatureModule
        CategoryFilterBadgeComponent,
        CategoryGridModule,
        CategoryPageRoutingModule,
        CategoryToolbarModule,
        CmsRenderLazyComponent,
        CommonModule,
        DisplayFilterComponent,
        TranslateModule.forChild(),
        ElementObserverDirective,
        HideOnScrollDirective,
        ParagraphToggleComponent,
        ProductModule,
        ProductsArrayFeatureCoreModule,
        RelatedProductsComponent, // Esta es dependencia de CategoryLayoutComponent, si se pasa ésta a standalone mover a sus imports.
        RelatedProductsCoreModule,
    ],
    declarations: [
        CategoryLayoutComponent,
        CategorySeoComponent,
    ],
    providers: [
        provideState({ name: 'category-page', reducer: CategoryPageReducer }),
        provideEffects(CategoryPageEffects, GridTypeEffects),
        CategoryPageResolver,
        CategoryPageService,
        ChangeUrlService,
        HeraclesService,
        MenuCategoriesService,
        ProductFilterService,
        StaticResourceService,
    ],
})

export class CategoryPageModule {
    constructor(private readonly store: Store) {
        // eslint-disable-next-line no-secrets/no-secrets
        this.store.dispatch(LoadAnalyticsModule({ moduleName: 'AnalyticsCategoryModule' }));
    }
}
